export const title = 'Usuários com notificações ativas';

{/* Conteúdo TBD */}
